import { render, staticRenderFns } from "./CreateSpecification.vue?vue&type=template&id=509d1ea1&"
import script from "./CreateSpecification.vue?vue&type=script&lang=js&"
export * from "./CreateSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports